import Grid from '@decisiv/ui-components/lib/components/Grid';
import styled from 'styled-components';

export const FormContainer = styled(Grid.Container)`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
